<template>
    <div style="height: 100%;overflow: auto;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <!--<el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
        </el-form>-->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
            <div v-for="(item,key) in beautySaleLogs" :key="key" style="margin-bottom: 20px;">
                <el-descriptions class="margin-top" direction="vertical"  :column="1" border  >
                    <el-descriptions-item>
                        <template slot="label">
                            {{item.accountdate}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].cardnumber}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].membername}}
                        </template>
                        <div v-for="(val,idx) in item.cardTransactionHistories" :key="idx">
                            {{val.projectname}}
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            具体的方案，赠送等等
                        </template>
                        <el-input type="textarea" v-model="item.beautySaleLog.programme" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-descriptions-item>
                    <!--<el-descriptions-item>
                        <template slot="label">
                            销售沟通细节记录
                        </template>
                        <el-input type="textarea" v-model="item.beautySaleLog.connected" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            销售时铺垫了什么项目
                        </template>
                        <el-input type="textarea" v-model="item.beautySaleLog.bedding" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-descriptions-item>-->
                </el-descriptions>    
                <van-button type="primary" color="#1989fa" size="large" @click="saveBeautySaleLog(item)">保存</van-button>
            </div>
        </van-list>
    </div>
</template>
<script>
export default {
    data() {
      return {
        storeid:localStorage.getItem("storeid"),
        brands:[],
        loading:true,
        finished:true,
        beautySaleLogs:[],
      }
    },
    created() {
        this.getCardTransactionHistoryByCardIdStore();
        //this.getStoreInfoByStructsOpen();
    },
    methods:{
        saveBeautySaleLog(item){
            if(!item.beautySaleLog.programme){
                this.$message.error("具体的方案，赠送等等");
                return;
            }
            /*if(!item.beautySaleLog.connected){
                this.$message.error("销售沟通细节记录");
                return;
            }
            if(!item.beautySaleLog.bedding){
                this.$message.error("销售时铺垫了什么项目");
                return;
            }*/
                let log=new Object();
                log.storeid=this.storeid;
                log.cardid=item.cardTransactionHistories[0].cardid;
                log.memberid=item.cardTransactionHistories[0].memberid;
                log.projectname="";
                log.accountdate=item.accountdate;
                for(let val of item.cardTransactionHistories){
                    if(log.projectname){
                        log.projectname=log.projectname+","+val.projectname;
                    }
                    else{
                        log.projectname=val.projectname;
                    }
                }
                log.why=item.beautySaleLog.why;
                log.programme=item.beautySaleLog.programme;
                log.connected=item.beautySaleLog.connected;
                log.bedding=item.beautySaleLog.bedding;
                log.uncultivated=item.beautySaleLog.uncultivated;
                this.$postw("hairmanager/saveHairSaleLog",log).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                        this.getCardTransactionHistoryByCardIdStore();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
        },
        storeChange(val){
            localStorage.setItem("storeid",val);
            this.storeid=val;
            this.getCardTransactionHistoryByCardIdStore();
        },
        getStoreInfoByStructsOpen(){
            let parentstoreid=localStorage.getItem("parentstoreid");
            let staffid=localStorage.getItem("staffid");
            this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
        },
        getCardTransactionHistoryByCardIdStore(){
            let staffid=localStorage.getItem("querystaffid");
            this.$post("hairmanager/getStaffHairSaleLogByStore",{storeid:this.storeid,staffid:staffid}).then(res=>{
                if(res.sucess){
                    this.beautySaleLogs=res.object;
                }
                else{
                    this.$message({message: res.message,type: 'error'});
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/manager/hairsalelog.vue